export default "__VITE_ASSET__DXrL8Jsh__"